import { pipe } from 'fp-ts/function';
import { createAuthorizedGetRequest, decode, fetchApi } from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { geolocationCodec } from '@/services/api/resources/geolocation/codec';

const baseUrl = '/v2/geolocate';
const ipUrl = `${baseUrl}/ip`;
const currencyUrl = (country: string) => `${baseUrl}/currency?country=${country}`;

export const getCurrency = (country: string) => pipe(
  currencyUrl(country),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(geolocationCodec)),
);

export const geolocate = () => pipe(
  ipUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(geolocationCodec)),
);
